import UsageEventsAPI from 'dashboard/api/usageEvents';

// First path segment under /app/accounts/:accountId/ -> sidebar menu item slug.
// Routes that are not in the sidebar (notifications, profile, search...) are not tracked.
const MENU_ITEM_BY_SEGMENT = {
  'inbox-view': 'inbox',
  dashboard: 'conversation',
  conversations: 'conversation',
  inbox: 'conversation',
  label: 'conversation',
  team: 'conversation',
  mentions: 'conversation',
  participating: 'conversation',
  unattended: 'conversation',
  custom_view: 'conversation',
  captain: 'captain',
  contacts: 'contacts',
  companies: 'companies',
  deals: 'deals',
  tasks: 'tasks',
  painel: 'panels',
  reports: 'reports',
  campaigns: 'campaigns',
  portals: 'portals',
  settings: 'settings',
};

const HEARTBEAT_INTERVAL_MS = 30 * 60 * 1000;
const PATH_PATTERN = /\/accounts\/(\d+)\/([^/?#]+)/;

export const parseUsagePath = path => {
  const match = PATH_PATTERN.exec(path || '');
  if (!match) return {};
  return { accountId: match[1], menuItem: MENU_ITEM_BY_SEGMENT[match[2]] };
};

let lastSentAt = 0;

const recordUsage = (accountId, menuItem) => {
  lastSentAt = Date.now();
  UsageEventsAPI.record(accountId, menuItem).catch(() => {});
};

// Fires only when the main sidebar item changes, never for navigation inside the same item.
export const trackMenuItemChange = (to, from, failure) => {
  if (failure) return;

  const { accountId, menuItem } = parseUsagePath(to.path);
  if (!menuItem || menuItem === parseUsagePath(from?.path).menuItem) return;

  recordUsage(accountId, menuItem);
};

// Keeps a long-lived single tab counted as active: re-sends the current menu item
// on user activity, at most once per HEARTBEAT_INTERVAL_MS.
const sendHeartbeat = () => {
  if (Date.now() - lastSentAt < HEARTBEAT_INTERVAL_MS) return;

  const { accountId, menuItem } = parseUsagePath(window.location.pathname);
  if (menuItem) recordUsage(accountId, menuItem);
};

export const startUsageHeartbeat = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') sendHeartbeat();
  });
  ['pointerdown', 'keydown'].forEach(eventName =>
    window.addEventListener(eventName, sendHeartbeat, {
      capture: true,
      passive: true,
    })
  );
};
